// @flow strict

import React from 'react';

import { SvgIcon, type SvgIconComponentProps } from './svg-icon';

/**
 * Icon for language switch.
 *
 * @param {SvgIconComponentProps} props - component props
 *
 * @returns {Node}
 */
export const LanguageSwitchIcon = (props: SvgIconComponentProps) => {
  return (
    <SvgIcon viewBox="0 0 11 7" name="OMQLanguageSwitchIcon" {...props}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke="#000"
        strokeLinecap="square"
        strokeWidth="1.8"
      >
        <path d="M0.375 0.375L4.125 4.125" transform="translate(1 1)" />
        <path
          d="M4.375 0.375L8.125 4.125"
          transform="translate(1 1) matrix(-1 0 0 1 12.5 0)"
        />
      </g>
    </SvgIcon>
  );
};
